// extracted by mini-css-extract-plugin
export default {"buttons":"GxEnW3VL0A86_KIF"};